// organize-imports-ignore
import "./polyfills";
import "@styles/index.css";
import { loadSdkThemeCssForBootstrap } from "@utils/loadSdkThemeCss";
import "./configs/statsig/suppress-noop-client-warn";
import React from "react";
import ReactDOM from "react-dom/client";
import { EnhancedApp } from "./App.tsx";

// Defer non-critical analytics/monitoring until after first paint / idle
const runOnIdle = (callback: () => void) => {
  if (typeof window !== "undefined" && typeof window.requestIdleCallback === "function") {
    // { timeout: 5000 } guarantees execution within 5 s even on a continuously-busy page.
    // Without a timeout, requestIdleCallback may never fire (e.g. during heavy animations).
    window.requestIdleCallback(callback, { timeout: 5000 });
    return;
  }

  // Fallback for Safari < 16: wait for the next animation frame (guarantees we are
  // past first paint), then yield once more to the task queue via setTimeout(0).
  // This is faster and more adaptive than a hard-coded 1500 ms delay.
  requestAnimationFrame(() => setTimeout(callback, 0));
};

void loadSdkThemeCssForBootstrap().then(() => {
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <EnhancedApp />
    </React.StrictMode>,
  );

  runOnIdle(() => {
    import("./deferred-init").then((m) => m.initDeferred());
  });
});
